/* eslint-disable max-len */
import React, {ReactElement} from 'react';

const SuccessIcon = ({
  width = 97.129,
  height = 97.129,
  ...rest
}: React.SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 97.129 97.129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}>
      <g id="Group_4960" data-name="Group 4960">
        <path
          id="Path_4958"
          data-name="Path 4958"
          d="M48.564,0A48.564,48.564,0,1,0,97.129,48.564,48.621,48.621,0,0,0,48.564,0ZM75.707,35.784,44.669,66.578a4.775,4.775,0,0,1-6.694.122L21.544,51.729a4.936,4.936,0,0,1-.365-6.816,4.815,4.815,0,0,1,6.816-.243L41.018,56.6,68.769,28.847a4.906,4.906,0,0,1,6.938,6.938Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
export default SuccessIcon;
